import React, { useState } from 'react';
import { ThemeTwoContactSection, ThemeTwoTitle } from '../themes';

import TarbajaForm from '../themes/ThemeTwo/common/TarbajaForm';
import ThemeTwoSpecialService from '../themes/ThemeTwo/common/ThemeTwoSpecialServices';
import getIcons from '../themes/functions/getIcons/getIcons';

const Tabs = ({ operator, actions, history }) => {
	const [selectedTab, setSelectedTab] = useState('contact');

	const renderLeftContent = () => {
		let heading = '';
		let subHeading = '';
		let contactInfo = null;

		if (selectedTab === 'contact') {
			heading = 'Contacto';
			contactInfo = (
				<div>
					<div className="info-item font10">
						<p>Completa el formulario de contacto con tus <br /> datos y el motivo de tu consulta.</p>
					</div>
					{operator.phone_number && (

						<div className="info-item font10 mt-5">
							<img src={getIcons('Headphone', operator)} alt="" />
							<span className="info-text font10">Teléfono: {operator.phone_number}</span>
						</div>
					)}
					{(operator.operator_name !== 'lineaazul' && operator.operator_name !== 'santarosa') && operator.phone_number && (
						<div className="info-item font10">
							<img src={getIcons('Whatsapp', operator)} alt="" />
							<span className="info-text font10">Whatsapp: +56 9 4915 6683</span>
						</div>
					)}
					{operator.email && (
						<div className="info-item font10 mt-2">
							<img src={getIcons('Email', operator)} alt="" />
							<span className="info-text font10">Email: {operator.email}</span>
						</div>
					)}
				</div>
			);
		} else if (selectedTab === 'specialServices') {
			heading = 'Servicios Especiales';
			subHeading = '¿Necesitas solicitar una cotización para servicios especiales? Te invitamos a ponerte en contacto por medio de nuestro formulario de cotizaciones y felices te atenderemos.';
			contactInfo = (
				<div>
					{operator.phone_number && (
						<div className="info-item font10">
							<img src={getIcons('Headphone', operator)} alt="" />
							<span className="info-text">Teléfono: {operator.phone_number}</span>
						</div>
					)}
					{operator.email && (
						<div className="info-item font10 mt-2">
							<img src={getIcons('Email', operator)} alt="" />
							<span className="info-text">Email: {operator.email}</span>
						</div>
					)}
				</div>
			);
		} else if (selectedTab === 'workWithUs') {
			heading = 'Trabaja con nosotros';
			subHeading = '';
			contactInfo = (
				<div>
					<div className="info-item font10">
						<span
							style={{
								display: 'block',


								paddingRight: '20px',
								paddingBottom: '20px',
							}}
						>
							Completa el siguiente formulario y adjunta los
							siguientes documentos:
						</span>
					</div>
					<div>
						<ul style={styles.list} className="mt-3 font10">
							<li style={styles.listitem}>Currículum Vitae formato PDF.</li>
							<li style={styles.listitem}>Certificado de Antecedentes.</li>
							<li style={styles.listitem}>Hoja de vida del conductor.</li>
							<li style={styles.listitem}>Certificado histórico de cotizaciones AFP.</li>
						</ul>
						<p className="mt-5 font10">
							También puedes postular enviando la documentación <br />
							señalada al siguiente correo: <br />
							<b>postulaciones@pullmansantarosa.cl</b>
						</p>
					</div>
				</div>
			);
		}

		return (
			<div>
				{operator && operator.operator_name === 'santarosa' ? (
					<div className="formtitle">
						<span>{heading}</span>
						<div className="line right rosaline">
							<img src="/assets/santarosa/icons/line.svg" alt="" />
						</div>
					</div>
				) : operator && operator.operator_name === 'buseslafit' ? (
					<div className="formtitle">
						<span>{heading}</span>
						<div className="line right blueline">
							<img src="/assets/buseslafit/icons/line.svg" alt="" />
						</div>
					</div>
				) : null}



				<div className="form-subtitle font10">{subHeading}</div>
				<div className="mt-5">{contactInfo}</div>
			</div>
		);
	};

	const renderRightContent = () => {
		switch (selectedTab) {
			case 'contact':
				return <ThemeTwoContactSection operator={operator} actions={actions} history={history} />;
			case 'specialServices':
				return <ThemeTwoSpecialService operator={operator} actions={actions} history={history} />;
			case 'workWithUs':
				return (
					<div
						className="form right-sec"
						style={{
							background: operator && operator.color_codes.primary_color || '#FFFFFF',
							position: 'relative',
							overflow: 'hidden',
							padding: 0,
							margin: 0,
							borderRadius: '8px',
							boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
							width: '100%',
						}}
					>
						<TarbajaForm operator={operator} actions={actions} history={history} />
					</div>
				);
			default:
				return null;
		}
	};

	return (
		<div className="new-container">
			<div className="d-flex new-container justify-content-between mt-5">
				<div className="left-sec">{renderLeftContent()}</div>
				<div className="right-sec">
					<div className="tab-strip">
						<div style={styles.tabContainer}>
							<button
								style={selectedTab === 'contact' ? styles.activeTab : styles.tab}
								onClick={() => setSelectedTab('contact')}
							>
								Formulario de contacto
							</button>
							<button
								style={selectedTab === 'specialServices' ? styles.activeTab : styles.middleTab}
								onClick={() => setSelectedTab('specialServices')}
							>
								Servicios especiales
							</button>
							<button
								style={selectedTab === 'workWithUs' ? styles.activeTab : styles.tab}
								onClick={() => setSelectedTab('workWithUs')}
							>
								Trabaja con nosotros
							</button>
						</div>
					</div>
					{renderRightContent()}
				</div>
			</div>
		</div>
	);
};

const styles = {
	tabContainer: {
		display: 'flex',
		width: '100%',
		position: 'relative',
		boxSizing: 'border-box',
		justifyContent: 'center', // Ensure centering of tabs
	},
	tab: {
		flex: 1, // Equal width for each tab
		padding: '15px 0px',
		cursor: 'pointer',
		backgroundColor: '#eff0f1',
		border: 'none',
		fontSize: '16px',
		boxShadow: 'rgb(52 52 52 / 38%) 2px 0px 3px 1px',
		borderRadius: '7px',
		zIndex: 1,
		textAlign: 'center',
		color: '#464647',
		position: 'relative',
		flexShrink: 0, // Prevent shrinking
	},
	activeTab: {
		flex: 1,
		padding: '15px 20px',
		cursor: 'pointer',
		backgroundColor: 'rgb(181 44 31)',
		border: 'none',
		fontSize: '16px',
		fontWeight: 'bold',
		color: 'white',
		boxShadow: 'rgb(52 52 52 / 38%) 2px 0px 3px 1px',
		borderRadius: '7px',
		textAlign: 'center',
		zIndex: 3, // Active tab on top
		position: 'relative',
		flexShrink: 0, // Prevent shrinking

	},
	middleTab: {
		flex: 1,
		padding: '15px 0px',
		cursor: 'pointer',
		backgroundColor: '#eff0f1',
		border: 'none',
		fontSize: '16px',
		boxShadow: 'rgb(52 52 52 / 38%) 2px 0px 3px 1px',
		borderRadius: '7px',
		zIndex: 2, // Middle tab should be slightly below active
		textAlign: 'center',
		position: 'relative',
		color: '#464647',
		flexShrink: 0, // Prevent shrinking
		marginLeft: '-10px', // Overlap the previous tab
		marginRight: '-10px', // Overlap the next tab
	},
	tabWrapper: {
		display: 'flex',
		width: '100%',
		position: 'relative',
	},
	list: {
		paddingLeft: '10px',
	},
	listitem: {
		listStyle: 'disc',
		paddingBottom: '5px',
	},
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/features/common/tabs.js